import { render } from "./PageProductDetail.vue?vue&type=template&id=5f6cee73"
import script from "./PageProductDetail.js?vue&type=script&lang=js"
export * from "./PageProductDetail.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PageProductDetail.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FPageProductDetail%2FPageProductDetail.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__